import React from "react";
import { StockTransferModal } from "../StockTransferModal";

const TRANSFER_OPTION = {
  id: "material-demo-customer",
  value: "Material_Demo_To_Customer",
  labelKey: "inventory.transferMaterialDemoToCustomer",
  party: "customer",
};

export function MaterialDemoToCustomerModal({ open, onOpenChange, onSuccess }) {
  return (
    <StockTransferModal
      open={open}
      onOpenChange={onOpenChange}
      onSuccess={onSuccess}
      transferOption={TRANSFER_OPTION}
    />
  );
}
